import { ranking } from '../../../mocks/news';

const rankBadge = (idx: number) =>
  idx === 0 ? 'bg-primary-500 text-background-50'
  : idx === 1 ? 'bg-accent-500 text-foreground-950'
  : idx === 2 ? 'bg-secondary-500 text-background-50'
  : 'bg-background-200 text-foreground-500';

const trendIcon = (t: string) =>
  t === 'up' ? 'ri-arrow-up-line text-accent-700'
  : t === 'down' ? 'ri-arrow-down-line text-foreground-400'
  : 'ri-sparkling-line text-primary-600';

const hotColor = (h: string) =>
  h === '爆' ? 'text-primary-600'
  : h === '热' ? 'text-accent-700'
  : 'text-foreground-400';

export default function Ranking() {
  return (
    <section id="ranking" className="scroll-mt-24 py-12 md:py-16 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
        {/* 左：榜单 */}
        <div className="lg:col-span-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">TRENDING NOW</span>
              <h2 className="mt-1 font-heading text-2xl md:text-4xl font-black text-foreground-950">今日热议飙升榜</h2>
            </div>
            <span className="hidden md:flex items-center gap-1.5 text-xs text-foreground-400">
              <i className="ri-arrow-up-down-line" aria-hidden="true" /> 每 5 分钟刷新
            </span>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden">
            {ranking.map((r, i) => (
              <div
                key={r.id}
                className="group cursor-pointer flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3.5 border-b border-background-100 last:border-0 hover:bg-background-100 transition"
              >
                <span className={`flex items-center justify-center w-7 h-7 md:w-8 md:h-8 shrink-0 rounded-lg font-heading font-black text-sm md:text-base ${rankBadge(i)}`}>
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-700 transition">
                    {r.title}
                  </h3>
                  <div className="mt-0.5 text-xs text-foreground-400">热度峰值 <span className="text-accent-700 font-medium">{r.value}</span></div>
                </div>
                <span className={`hidden sm:inline text-xs font-bold ${hotColor(r.hotTag)}`}>{r.hotTag}</span>
                <i className={`${trendIcon(r.trend)} text-sm shrink-0`} aria-hidden="true" />
              </div>
            ))}
          </div>
        </div>

        {/* 右：导流卡片 */}
        <aside className="lg:col-span-4 flex flex-col gap-5" aria-label="吃瓜小贴士">
          <div className="rounded-2xl bg-primary-500 text-background-50 p-6 md:p-7 overflow-hidden relative">
            <i className="ri-fire-fill absolute -right-4 -top-4 text-[120px] opacity-10" aria-hidden="true" />
            <span className="inline-flex items-center gap-1 rounded-full bg-background-50/20 px-2.5 py-1 text-xs font-semibold">
              <i className="ri-megaphone-line" aria-hidden="true" /> 编辑部提醒
            </span>
            <h3 className="mt-4 font-heading text-xl font-black leading-snug">吃到瓜，更要吃得清醒</h3>
            <p className="mt-3 text-sm text-background-100/90 leading-relaxed">
              榜单热度仅代表讨论量。面对反转频繁的大瓜，不妨先看时间线、再核信源、多听几方说法，别让情绪替你做判断。
            </p>
            <a href="#faq" className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-background-50 hover:gap-2.5 transition whitespace-nowrap cursor-pointer">
              阅读吃瓜守则 <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-price-tag-3-line text-accent-600" aria-hidden="true" /> 今日热搜关键词
            </h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {['# 塌房', '# 翻车', '# 名场面', '# 实锤', '# 疯传', '# 复盘', '# 辟谣', '# 出圈', '# 二创'].map((k) => (
                <span key={k} className="cursor-pointer whitespace-nowrap rounded-full bg-background-100 border border-background-200 px-3 py-1 text-xs text-foreground-700 hover:bg-accent-100 hover:text-accent-800 hover:border-accent-200 transition">
                  {k}
                </span>
              ))}
            </div>
            <p className="mt-4 text-xs text-foreground-400 leading-relaxed">点击热点标签，可在上方「猛料大厅」中定位对应栏目内容。</p>
          </div>
        </aside>
      </div>
    </section>
  );
}